
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"HIERARCHY_one":"Hierarchie","HIERARCHY_other":"Hierarchien","DIMENSION_one":"Dimension","DIMENSION_other":"Dimensionen","MEASURE_one":"Kennzahl","MEASURE_other":"Kennzahlen"},"en":{"HIERARCHY_one":"Hierarchy","HIERARCHY_other":"Hierarchies","DIMENSION_one":"Dimension","DIMENSION_other":"Dimensions","MEASURE_one":"Measure","MEASURE_other":"Measures"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();